import { FormLayout, Modal, Form, Select } from '@shopify/polaris';
import { useEffect, useState } from 'react';
import helpers from 'helpers';
import { lengthLessThan, notEmpty, useField, useForm } from '@shopify/react-form';
import __ from 'languages/index';
import {
  TypedAddress_suggestion,
  useMutateGetAddressSuggestion,
  useMutateCreateAddressSuggestion,
  useUpdateAddressSuggestion,
} from 'queries/address_suggestion.query';
import AutocompleteAddress from 'components/addressAutoComplete';
import { useMutateGetJourneys } from 'queries/journey.query';
const provinceData = require('config/provinceData.json');

/**
 *   Create upload Modal for Notification
 */

// eslint-disable-next-line import/no-anonymous-default-export

export default function PickupTimeRuleModal({
  onClose,
  show,
  currentAddressSuggestionID,
}: {
  onClose: Function;
  show: boolean;
  currentAddressSuggestionID?: bigint;
}) {
  const { mutateAsync: createEntity, isPending: creating, isSuccess: creatingSuccess } = useMutateCreateAddressSuggestion();
  const { mutateAsync: updateEntity, isPending: updating, isSuccess: updateSuccess } = useUpdateAddressSuggestion();
  const { mutateAsync: getVehicle, data: vehicleData } = useMutateGetAddressSuggestion();
  const { mutateAsync: getJourneyData, data: journeyData } = useMutateGetJourneys();

  useEffect(() => {
    getJourneyData({
      limit: 10,
      journey_status: 1,
    });
  }, []);

  // 2. Chuyển đổi JSON thành options cho component Select
  const journeyOptions = [
    { label: 'Chọn một hành trình', value: '' }, // Thêm một lựa chọn mặc định
    ...(journeyData || []).map(({ id, journey_name }) => ({
      label: String(journey_name),
      value: String(id),
    })),
  ];
  const provinceOptions = [
    { label: 'Chọn một địa điểm', value: '' }, // Thêm một lựa chọn mặc định
    ...Object.entries(provinceData || []).map(([id, name]) => ({
      label: String(name),
      value: String(id),
    })),
  ];

  /** Hết code lấy user role ra ... */
  const [entity, setEntity] = useState<TypedAddress_suggestion>(null);
  useEffect(() => {
    if (vehicleData) setEntity(vehicleData);
  }, [vehicleData]);

  useEffect(() => {
    if (currentAddressSuggestionID) {
      getVehicle(currentAddressSuggestionID);
    } else {
      setEntity(null);
    }
  }, [currentAddressSuggestionID]);

  const useFields = {
    address: useField<string>({
      value: entity?.address ?? '',
      validates: [
        notEmpty('Không được để trống trường này.'),
        lengthLessThan(250, 'No more than 250 characters.'),
        (inputValue) => {
          if (inputValue.length < 2) {
            return 'Your field is too short!';
          }
        },
      ],
    }),
    address_data: useField<string>({
      value: entity?.address_data ?? '',
      validates: [],
    }),

    journey_from_id: useField<string>({
      value: String(entity?.journey_from_id ?? 0),
      validates: [notEmpty('Không được để trống trường này.')],
    }),
    journey_id: useField<string>({
      value: String(entity?.journey_id ?? 0),
      validates: [notEmpty('Không được để trống trường này.')],
    }),
  };

  const { fields, submit, dirty, reset } = useForm({
    fields: useFields,

    async onSubmit(values) {
      try {
        // create new
        if (!currentAddressSuggestionID) {
          await createEntity({
            address: values.address,
            address_data: values.address_data,
            journey_id: values.journey_id,
            journey_from_id: values.journey_from_id,
          });
        } else {
          await updateEntity({
            id: String(currentAddressSuggestionID),
            address: values.address,
            address_data: values.address_data,
            journey_id: values.journey_id,
            journey_from_id: values.journey_from_id,
          });
        }
      } catch (e: any) {
        if (e.params !== undefined) {
          if (e.params.field !== undefined) {
            useFields[e.params.field].setError(__('check_this_field_again'));
          }
        }
      }
      return { status: 'success' };
    },
  });
  /* End form */

  // const allErrors = Object.entries(useFields)
  //   .filter(([_, field]) => field.error)
  //   .map(([key, field]) => `${key}: ${field.error}`);

  useEffect(() => {
    if (updateSuccess || creatingSuccess) {
      helpers.resetForm(useFields);
      onClose();
    }
  }, [updateSuccess, creatingSuccess]);

  useEffect(() => {
    if (!currentAddressSuggestionID) {
      helpers.resetForm(useFields);
      setEntity(null);
    }
  }, [currentAddressSuggestionID]);

  const Actual_page = (
    <Modal
      open={show}
      onClose={() => onClose()}
      title={currentAddressSuggestionID ? 'Cập nhật địa chỉ' : 'Tạo Địa chỉ'}
      primaryAction={{
        content: currentAddressSuggestionID ? 'Cập nhật' : 'Tạo',
        disabled: !dirty,
        loading: updating || creating,
        onAction: submit,
      }}
      secondaryActions={[
        {
          content: 'Close',
          onAction: () => onClose(),
        },
      ]}
    >
      <Modal.Section>
        <Form onSubmit={submit}>
          <FormLayout>
            <AutocompleteAddress
              autoComplete="off"
              placeholder="Địa chỉ"
              label={``}
              value={useFields.address.value}
              onChange={(shortAddress) => {
                useFields.address.onChange(shortAddress);
              }}
              selectedCallback={({ latlng, ward, province }) => {
                fields.address_data.onChange(
                  JSON.stringify({
                    latlng,
                    ward,
                    province,
                  })
                );
              }}
              error={useFields.address.error}
            />
            <Select
              label="Điểm đón/trả"
              requiredIndicator
              options={provinceOptions}
              onChange={(selectedId) => fields.journey_from_id.onChange(selectedId)}
              value={fields.journey_from_id.value} // Giá trị của Select là ID (lấy từ trường _geo)
              error={fields.journey_from_id.error} // Hiển thị lỗi từ trường _geo
            />
            <Select
              label="Trong hành trình nào?"
              requiredIndicator
              options={journeyOptions}
              onChange={(selectedId) => fields.journey_id.onChange(selectedId)}
              value={fields.journey_id.value} // Giá trị của Select là ID (lấy từ trường _geo)
              error={fields.journey_id.error} // Hiển thị lỗi từ trường _geo
            />
          </FormLayout>
        </Form>
      </Modal.Section>
    </Modal>
  );

  return <>{Actual_page}</>;
}

